const doc = [({"da":({"js":({"admin":({"photo_sessions":({"nav":({"overview":"Oversigt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;